
    import { Options, Vue } from 'vue-class-component';

    @Options({
        props: {
            icon: {
                type: [String, Object, Array],
                default: 'ap-icon-loader',
            },
        },
    })
    export default class ApLoader extends Vue {}
